// src/ConsumerApp/DesignSystem/Navigation/components/DirectorySeoSection.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../../../../assets/theme/theme';

const SEO_DATA = {
  popularSearches: {
    title: 'Popular Searches',
    rows: [
      {
        label: 'Products',
        items: [
          'Cement',
          'Wall Putty',
          'Tile Adhesive',
          'Waterproofing',
          'Wires',
          'PVC Pipes',
          'Switches',
          'MCB',
        ],
      },
      {
        label: 'Brands',
        items: [
          'KCP',
          'UltraTech',
          'Fevicol',
          'Dr. Fixit',
          'Finolex',
          'Legrand',
          'Starhalkar',
          'Birla Opus',
          'Asian Paints',
          'SENTRIQ',
        ],
      },
      {
        label: 'Categories',
        items: [
          'Cement',
          'Chemicals',
          'Pipes & Fittings',
          'Switches & Switchgear',
          'Wires & Cables',
          'Paints',
          'Tile Fixing',
        ],
      },
      {
        label: 'Shop by Need',
        items: [
          'Painting',
          'Waterproofing',
          'Electrical Work',
          'Plumbing Repairs',
          'Tile Installation',
          'Wall Preparation',
        ],
      },
    ],
  },
  categories: {
    title: 'Categories',
    items: [
      'Cement',
      'Construction Chemicals',
      'Electrical Pipes & Fittings',
      'Electrical Switches & Switchgear',
      'Paints',
      'Tile Fixing Products',
      'Electrical Wires & Cables',
      'Paint Accessories',
      'Sanitary Fittings',
      'Wall Putties & Textures',
    ],
  },
  cities: {
    title: 'Cities',
    items: [
      { name: 'Vijayawada', active: true, badge: null },
      { name: 'Hyderabad', active: false, badge: 'Coming soon' },
    ],
  },
};

export default function DirectorySeoSection() {
  const navigate = useNavigate();

  const handleSearchClick = (keyword) => {
    navigate(`/consumer/search?q=${encodeURIComponent(keyword)}`);
  };

  return (
    <section className="bb-directory-seo-container">
      <style>{`
        .bb-directory-seo-container {
          width: 100%;
          display: flex;
          flex-direction: column;
          gap: 24px;
          padding-bottom: 32px;
          border-bottom: 1px solid #E2E8F0;
          box-sizing: border-box;
          user-select: none;
        }

        .bb-directory-block {
          display: flex;
          flex-direction: column;
          gap: 12px;
          width: 100%;
        }

        .bb-directory-heading {
          font-family: ${theme.typography?.headingMD?.fontFamily || 'sans-serif'};
          font-size: 15px;
          font-weight: 800;
          color: #0F172A;
          margin: 0;
          letter-spacing: -0.2px;
        }

        /* ── Popular Searches Row Style ── */
        .bb-directory-search-row {
          display: flex;
          align-items: baseline;
          gap: 12px;
          font-size: 13px;
          line-height: 22px;
          flex-wrap: wrap;
        }

        .bb-directory-label {
          min-width: 110px;
          font-weight: 700;
          color: #334155;
          flex-shrink: 0;
        }

        .bb-directory-items-wrap {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
        }

        .bb-directory-interactive-link {
          color: #64748B;
          cursor: pointer;
          transition: color 0.15s ease;
          font-weight: 500;
          display: inline-block;
          background: none;
          border: none;
          padding: 0;
          font-size: inherit;
          text-align: left;
        }

        .bb-directory-interactive-link:hover {
          color: #E9001E;
          text-decoration: underline;
        }

        .bb-directory-separator {
          color: #CBD5E1;
          font-size: 11px;
          user-select: none;
          padding: 0 1px;
        }

        /* ── Categories 4-Column Grid ── */
        .bb-directory-category-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px 18px;
          width: 100%;
        }

        .bb-directory-grid-link {
          font-size: 13px;
          color: #475569;
          font-weight: 500;
          cursor: pointer;
          text-align: left;
          background: none;
          border: none;
          padding: 0;
          transition: color 0.15s ease;
          width: fit-content;
        }

        .bb-directory-grid-link:hover {
          color: #E9001E;
          text-decoration: underline;
        }

        /* ── Cities Row ── */
        .bb-directory-cities-row {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 13px;
          flex-wrap: wrap;
        }

        .bb-city-item {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          color: #475569;
          font-weight: 500;
          cursor: pointer;
          background: none;
          border: none;
          padding: 0;
        }

       /*  .bb-city-item.active:hover {
          color: #E9001E;
          text-decoration: underline;
        } */

        .bb-city-badge {
          font-size: 10px;
          font-weight: 600;
          color: #94A3B8;
        }

        /* ── Responsive Tablet View ── */
        @media (max-width: 900px) {
          .bb-directory-category-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 10px 14px;
          }
          .bb-directory-search-row {
            flex-direction: column;
            gap: 4px;
          }
          .bb-directory-label {
            min-width: 100%;
          }
        }

        /* ── Responsive Mobile View (Fully visible & touch-friendly) ── */
        @media (max-width: 640px) {
          .bb-directory-seo-container {
            display: flex !important;
            gap: 20px;
            padding-bottom: 24px;
          }

          .bb-directory-heading {
            font-size: 14px;
          }

          .bb-directory-search-row {
            flex-direction: column;
            gap: 3px;
            font-size: 12px;
            line-height: 20px;
          }

          .bb-directory-label {
            min-width: 100%;
            font-size: 12px;
          }

          .bb-directory-category-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px 12px;
          }

          .bb-directory-grid-link {
            font-size: 12px;
            line-height: 17px;
          }

          .bb-directory-cities-row {
            font-size: 12px;
            gap: 8px;
          }
        }
      `}</style>

      {/* 1. POPULAR SEARCHES */}
      <div className="bb-directory-block">
        <h4 className="bb-directory-heading">{SEO_DATA.popularSearches.title}</h4>
        {SEO_DATA.popularSearches.rows.map((row, idx) => (
          <div key={idx} className="bb-directory-search-row">
            <span className="bb-directory-label">{row.label} :</span>
            <div className="bb-directory-items-wrap">
              {row.items.map((item, itemIdx) => (
                <React.Fragment key={itemIdx}>
                  <button
                    type="button"
                    className="bb-directory-interactive-link"
                    onClick={() => handleSearchClick(item)}
                  >
                    {item}
                  </button>
                  {itemIdx < row.items.length - 1 && (
                    <span className="bb-directory-separator">|</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* 2. CATEGORIES */}
      <div className="bb-directory-block">
        <h4 className="bb-directory-heading">{SEO_DATA.categories.title}</h4>
        <div className="bb-directory-category-grid">
          {SEO_DATA.categories.items.map((cat, catIdx) => (
            <button
              key={catIdx}
              type="button"
              className="bb-directory-grid-link"
              onClick={() => handleSearchClick(cat)}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* 3. CITIES */}
      <div className="bb-directory-block">
        <h4 className="bb-directory-heading">{SEO_DATA.cities.title}</h4>
        <div className="bb-directory-cities-row">
          {SEO_DATA.cities.items.map((city, cIdx) => (
            <React.Fragment key={cIdx}>
              <button
                type="button"
                className={`bb-city-item ${city.active ? 'active' : ''}`}
               /*  onClick={() => {
                  if (city.active) handleSearchClick(city.name);
                }} */
              >
                <span>{city.name}</span>
                {city.badge && <span className="bb-city-badge">({city.badge})</span>}
              </button>
              {cIdx < SEO_DATA.cities.items.length - 1 && (
                <span className="bb-directory-separator">|</span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}